export interface PhoneWithChannel {
  Id: number;
  ChannelId?: string;
  CompanyId?: number;
  AssetId?: number;
  AnswerTime?: number;
  CallCenter: boolean;
  CallsInLast30Days?: number;
  CampaignIdExternal: string;
  CampaignStatus: boolean;
  ChannelType: string;
  ChannelTypeId: number;
  ChannelName: string;
  CompanyTitle: string;
  DialOption: string;
  Email: string;
  Expose: number;
  ExposeString: string;
  GreetingIn: string;
  GreetingOut: string;
  Active: boolean;
  IgnoreInSync: boolean;
  PhoneDescription: string;
  PhoneForSms: string;
  PhoneNumber: string;
  PhoneStatus: string;
  AssetTypeId?: number;
  RecordOption: string;
  RedirectPhone: string;
  RedirectPhoneForUi: string;
  RingbackTone: string;
  StatusId: number;
  VirtualPhoneProviderId?: number;
  TotalCallSeconds: string;

  AverageCallSeconds: string;
  NumberOfAnsweredCalls: number;
  NumberOfMissedCalls: number;
}

export enum PhoneStatus {
  None = 0,
  Active = 1,
  InActive = 2,
  Released = 3,
}
